export const SET_USER_INFO = "SET_USER_INFO";


export const setLoggedUser = (payload) => {
    return {type: SET_USER_INFO, payload};
}

